import {Card, Col, Row} from "antd";
import {Outlet} from "react-router-dom";

const ErrorLayout = () => {
  return (
    <>
      <Card>
        {/* <Row style={{height: "50vh"}}> */}
        <Row>
          <Col className="w-100 d-flex justify-content-center align-items-center">
            <Outlet />
          </Col>
        </Row>
      </Card>
    </>
  );
};

export default ErrorLayout;
